<button (click)="downloadPdf()" [disabled]="(hasData | async) === false" class="btn btn-sm btn-white" type="button">
  {{ "oereb.auszugKompakt" | translate }}
</button>
